/* eslint-disable */
import {
  Box,
  Breadcrumbs,
  Button,
  ButtonMenu,
  ButtonMenuItem,
  Card,
  Flex,
  Heading,
  HelpIcon,
  LinkExternal,
  Spinner,
  Text,
  useTooltip,
  CloseIcon,
  useMatchBreakpoints,
} from '@noahswap/uikit'
import Page from 'components/Layout/Page'
import { NextLinkFromReactRouter } from 'components/NextLink'
import { useTranslation } from '@noahswap/localization'
import { useState, useMemo, useEffect, useRef } from 'react'
import { usePoolChartData } from 'state/info/hooks'
import styled from 'styled-components'
import { getBlockExploreLink } from 'utils'
import { CurrencyLogo, DoubleCurrencyLogo } from 'views/Info/components/CurrencyLogo'
import ChartCard from 'views/Info/components/InfoCharts/ChartCard'
import TransactionTable from 'views/Info/components/InfoTables/TransactionsTable'
import Percent from 'views/Info/components/Percent'
import SaveIcon from 'views/Info/components/SaveIcon'
import { formatAmount, formatPrice, formatUsd, formatNumber } from 'utils/formatInfoNumbers'
import usePoolDatas from 'state/info/queries/pools/poolData'
import Io from 'socket'
import { PoolData } from 'state/info/types'
import { getKlinePairs, getRecords } from 'service/service'
import fetchTopTransactions from 'state/info/queries/protocol/transactions'
import chainUtils from 'service/chainUtils'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import CFClient from 'socket/cfws'
import { getSub, truncateZero } from 'utils/formatBalance'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { CopyButton } from 'components/CopyButton'

const ContentLayout = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-gap: 1em;
  margin-top: 16px;
  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    display: flex;
    flex-direction: column-reverse;
  }
`

const LockedTokensContainer = styled(Flex)`
  padding: 16px 4px;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  border-radius: 16px;
  // max-width: 280px;
`

const StyledButton = styled(Button)`
  font-weight: 400;
  font-size: 14px;
  color: #000;
  opacity: 1 !important;
  border-width: 1px;
  /* width: 100%; */
  height: 40px;
  padding: 0 10px;
  width: 96%;
`

const PoolPage: React.FC<React.PropsWithChildren<{ address: string }>> = ({ address: routeAddress }) => {
  const { isDesktop } = useMatchBreakpoints()
  const isMobile = isDesktop === false
  // const { t } = useTranslation()
  const {
    currentLanguage: { locale },
    t,
  } = useTranslation()

  const [showKline, setShowKline] = useState(false)
  const router = useRouter()
  // const parsedQueryChainId = Number(router.query.chainId)
  // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId'))

  // In case somebody pastes checksummed address into url (since GraphQL expects lowercase address)
  const address = routeAddress.toLowerCase()
  const [poolData, setPoolData] = useState<PoolData>({
    address: '',
    token0: { address: '', name: '', symbol: '' },
    token1: { address: '', name: '', symbol: '' },
  })
  // fetch data for unfetched pools and update them
  const { error: poolDataError, data: poolDatas } = usePoolDatas(address, true)

  useEffect(() => {
    if (poolDatas && !poolDataError) {
      if (Object.keys(poolDatas).length === 1) {
        setPoolData(poolDatas[address])
        // console.log('更新了poolDatas', poolDatas)
      }
    }
  }, [poolDataError, poolDatas, address])

  // debugger
  const chartData = usePoolChartData(address)

  const [tokenPriceData, setTokenPriceData] = useState([])
  const [type, setType] = useState(1)
  const [transactions, setTransactions] = useState([])
  const [loading, setLoading] = useState(false)
  const [KLineTime, setKLineTime] = useState('15') // 默认取15分钟数据, 原赋值minute15, 现改为15
  const [isDivVisible, setDivVisible] = useState(true)

  const reinitializePageRef = useRef(true)
  // 判断是否有k线
  useEffect(() => {
    const { baseURL, chainid } = chainUtils()
    const fetch = async () => {
      const params = {
        pairId: address,
      }
      const { data, code } = await getKlinePairs(params, { baseURL, chainid })
      if (!code) {
        if (data?.length > 0) {
          setShowKline(true)
        } else {
          setShowKline(false)
        }
      }
    }
    fetch()
  }, [address, showKline])

  // kline data 暂时注释
  // useEffect(() => {
  //   let uri = ''
  //   const env = process.env.NODE_ENV
  //   // if (chainId === 15557) {
  //   //   if (process.env.NODE_ENV === 'development') {
  //   //     uri = 'ws://192.168.50.2:10078'
  //   //   } else {
  //   //     uri = 'wss://testapi.noahark.pro/aws'
  //   //   }
  //   // } else {
  //   // uri = 'wss://api.noahark.pro/aws'
  //   // }

  //   // uri = process.env.NODE_ENV === 'development' ? 'ws://192.168.50.2:10078' : 'wss://api.noahark.io/aws'
  //   uri = 'wss://api.noahark.io/aws'
  //   // if (reinitializePageRef.current === true) {
  //   const client = new CFClient({ env, uri, debug: false })
  //   // }

  //   if (KLineTime) {
  //     Io.cfwsUnsubscribe(客户)
  //   }
  //   if (address && poolData?.token0.address && showKline && KLineTime) {
  //     const params = {
  //       resolution: KLineTime,
  //       symbol: poolData?.token0.address,
  //       pairId: address,
  //       from: 1672502400,
  //       to: Math.floor(Date.now() / 1000),
  //     }
  //     Io.cfwsKline(client, params, KLineTime, true, (response, way) => {
  //       // reinitializePageRef.current = false
  //       // console.log(response.klines, 'responseresponseresponse.klines')
  //       setTokenPriceData([])
  //       if (way === 'all') {
  //         if (response.klines.length === 0) {
  //           // callback && callback({ s: 'no_data' })
  //           setTokenPriceData([])
  //         } else {
  //           const bars = []
  //           // eslint-disable-next-line no-restricted-syntax
  //           for (const element of response.klines) {
  //             const barTime = element.time / 1000
  //             if (barTime >= 1672502400 && barTime <= Math.floor(Date.now() / 1000)) {
  //               bars.push(element)
  //             }
  //           }
  //           bars.sort((l, r) => (l.time > r.time ? 1 : -1))
  //           setTokenPriceData(bars)
  //         }
  //       } else {
  //         // console.log(response, 'responseresponse')
  //         // const listenerGUID = `${symbol.toLowerCase()}_${this.resolution.toLowerCase()}`;
  //         // const _listenerGUID = listenerGUID.replace('+', '_');
  //         // console.log(_listenerGUID);
  //         // const realtimeCallback = this.realtimeCallback[_listenerGUID];
  //         // if (typeof realtimeCallback === 'function') {
  //         //   realtimeCallback(response.klines[0]);
  //         // }
  //       }
  //     })
  //     Io.cfwsUnsubscribe(client)
  //   }
  //   // return () => { Io.cfwsUnsubscribe(client) }
  // }, [address, poolData?.token0, showKline, KLineTime])

  // info页面交易记录
  let timer: any

  const fetchData = ({ baseURL, chainid }) => {
    // setLoading(true)
    timer = clearTimeout(timer)
    //
    const fetch = async () => {
      const params = {
        type,
        currPage: 1,
        pageSize: 100,
        pairId: address,
      }
      // const data = await fetchTopTransactions(params)
      let datas = []
      try {
        const { code, data } = await getRecords(params, { baseURL, chainid })
        if (!code) {
          datas = data
            ?.map((v) => {
              return {
                type: params.type,
                direction: v.direction,
                amountToken0: v.count0,
                amountToken1: v.count1,
                token0Symbol: v.symbol0,
                token1Symbol: v.symbol1,
                timestamp: new Date(v.block_time).getTime() / 1000,
                pair: v.pair_id,
                hash: v.trx_id,
                sender: v.owner,
                amountUSD: v.operate_usd,
              }
            })
            ?.sort((a, b) => {
              return parseInt(b.timestamp, 10) - parseInt(a.timestamp, 10)
            })
        } else {
          datas = []
        }
      } catch {
        datas = []
      }

      if (datas) {
        setTransactions(datas)
      }
      // setTimeout(() => {
      //   setLoading(false)
      // }, 500);
    }
    fetch()
    timer = setTimeout(() => {
      fetchData({ baseURL, chainid })
    }, 10000)
  }
  useEffect(() => {
    const { baseURL, chainid } = chainUtils()
    fetchData({ baseURL, chainid })
    return () => {
      clearTimeout(timer)
    }
  }, [type, address])

  let symbolChange = {
    token0: poolData?.token0,
    token1: poolData?.token1,
  }

  if (poolData?.direction === 1) {
    symbolChange = {
      token0: poolData?.token1,
      token1: poolData?.token0,
    }
  }

  const symbolArray = [
    '0xfA9343C3897324496A05fC75abeD6bAC29f8A40f',
    '0x922D641a426DcFFaeF11680e5358F34d97d112E1',
    '0xeFAeeE334F0Fd1712f9a8cc375f427D9Cdd40d73',
    '0x765277EebeCA2e31912C9946eAe1021199B39C61',
    '0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b',
    '0x461d52769884ca6235B685EF2040F47d30C94EB5',
  ]
  // const symbolArr = ['DAI', 'USDT', 'USDC']
  // if (poolData?.token0?.symbol === 'WEOS' && !symbolArr.find((item) => item === poolData?.token1?.symbol)) {
  //   symbolChange = {
  //     token0: poolData?.token1,
  //     token1: poolData?.token0,
  //   }
  // }
  const handleCloseClick = () => {
    // console.log('ddsadsa')
    setDivVisible(false)
  }
  // console.log('poolData外', poolData)

  const priceChange =
    poolData?.priceChange > 0
      ? `+${poolData?.priceChange.toFixed(2)}`
      : poolData?.priceChange === 0
      ? '0.00'
      : `-${Math.abs(poolData?.priceChange).toFixed(2)}`
  return (
    <Page symbol={poolData ? `${poolData?.token0?.symbol} / ${poolData?.token1?.symbol}` : null}>
      {/* <Page> */}
      {/* {poolData != undefined && poolData?.token0?.address ? ( */}
      <>
        {isMobile ? (
          <>
            {isDivVisible &&
              (symbolArray.some((item) => item.toLowerCase() === poolData?.token0?.address) ||
                symbolArray.some((item) => item.toLowerCase() === poolData?.token1?.address)) && (
                <div
                  style={{
                    background: 'rgba(255, 255, 255, .38)',
                    fontSize: '14px',
                    lineHeight: '18px',
                    padding: '10px 10px 10px 10px',
                    borderRadius: '10px',
                    marginBottom: '15px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ paddingRight: '10px' }}>
                    <img src="/images/small-img/warning.png" alt="" width={20} style={{ marginBottom: '-3px' }} />
                    &nbsp;{t('noah482')}
                  </div>
                  <div
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}
                    onClick={handleCloseClick}
                  >
                    <CloseIcon width="24px" color="#000" />
                  </div>
                </div>
              )}
            {/* 行情 */}
            <Flex>
              {poolData?.direction === 1 ? (
                <div style={{ display: 'flex' }}>
                  <CurrencyLogo
                    address={poolData?.token1?.address}
                    symbol={poolData?.token1?.symbol}
                    size="30px"
                    // firstimg
                  />
                  <CurrencyLogo address={poolData?.token0?.address} symbol={poolData?.token0?.symbol} size="30px" />
                </div>
              ) : (
                <div style={{ display: 'flex' }}>
                  <CurrencyLogo
                    address={poolData?.token0?.address}
                    symbol={poolData?.token0?.symbol}
                    size="30px"
                    // firstimg
                  />
                  <CurrencyLogo address={poolData?.token1?.address} symbol={poolData?.token1?.symbol} size="30px" />
                </div>
              )}

              <Flex position="relative" flexDirection="column" style={{ marginLeft: '6px', marginBottom: '10px' }}>
                <Text bold ml="5px" fontSize="14px" lineHeight="18px">
                  {poolData?.direction === 1
                    ? `${poolData?.token1?.symbol}/${poolData?.token0?.symbol}`
                    : `${poolData?.token0?.symbol}/${poolData?.token1?.symbol}`}
                  {/* {`${poolData?.token0?.symbol}/${poolData?.token1?.symbol}`} */}
                </Text>
                {poolData?.direction === 1 ? (
                  <Flex alignItems="center" style={{ height: '16px', marginLeft: '4px' }}>
                    <CopyButton
                      width="24px"
                      text={poolData?.token1?.address}
                      address={poolData?.token1?.address}
                      iconColor
                      tooltipMessage={t('noah179')}
                      tooltipTop={40}
                      tooltipRight={120}
                    />
                    <Text color="#92929B" mr="10px" fontSize="12px">
                      |
                    </Text>
                    <CopyButton
                      width="24px"
                      text={poolData?.token0?.address}
                      address={poolData?.token0?.address}
                      iconColor
                      tooltipMessage={t('noah179')}
                      tooltipTop={40}
                      tooltipRight={0}
                    />
                  </Flex>
                ) : (
                  <Flex alignItems="center" style={{ height: '16px', marginLeft: '4px' }}>
                    <CopyButton
                      width="24px"
                      text={poolData?.token0?.address}
                      address={poolData?.token0?.address}
                      iconColor
                      tooltipMessage={t('noah179')}
                      tooltipTop={40}
                      tooltipRight={120}
                    />
                    <Text color="#92929B" mr="10px" fontSize="12px">
                      |
                    </Text>
                    <CopyButton
                      width="24px"
                      text={poolData?.token1?.address}
                      address={poolData?.token1?.address}
                      iconColor
                      tooltipMessage={t('noah179')}
                      tooltipTop={40}
                      tooltipRight={0}
                    />
                  </Flex>
                )}
              </Flex>
            </Flex>
            <Flex justifyContent="space-between" mb="16px" flexDirection={['column', 'column', 'row']}>
              <Flex justifyContent={[null, null, 'flex-end']} mt={['8px', '8px', 0]}>
                {poolData?.token0?.address && poolData?.token1?.address && (
                  <NextLinkFromReactRouter
                    to={`/add/${poolData?.token0?.address}/${poolData?.token1?.address}`}
                    style={{ flex: 1 }}
                  >
                    <StyledButton>{t('noah10')}</StyledButton>
                  </NextLinkFromReactRouter>
                )}
                <NextLinkFromReactRouter
                  to={`/swap?inputCurrency=${poolData?.token0.address}&outputCurrency=${poolData?.token1.address}`}
                  style={{ flex: 1 }}
                >
                  <StyledButton variant="secondary" style={{ borderColor: '#000' }}>
                    {t('noah80')}
                  </StyledButton>
                </NextLinkFromReactRouter>
                <LinkExternal href={getBlockExploreLink(address, 'address')} showIcon={false} style={{ flex: 1 }}>
                  <StyledButton variant="secondary" style={{ borderColor: '#000' }}>
                    {t('noah6')}
                  </StyledButton>
                </LinkExternal>
              </Flex>
            </Flex>
          </>
        ) : (
          <div>
            {isDivVisible &&
              (symbolArray.some((item) => item.toLowerCase() === poolData?.token0?.address) ||
                symbolArray.some((item) => item.toLowerCase() === poolData?.token1?.address)) && (
                <div
                  style={{
                    background: 'rgba(255, 255, 255, .38)',
                    fontSize: '14px',
                    lineHeight: '18px',
                    padding: '10px 10px 10px 10px',
                    borderRadius: '10px',
                    marginBottom: '15px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ paddingRight: '10px' }}>
                    <img src="/images/small-img/warning.png" alt="" width={20} style={{ marginBottom: '-3px' }} />
                    &nbsp;{t('noah482')}
                  </div>
                  <div
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}
                    onClick={handleCloseClick}
                  >
                    <CloseIcon width="24px" color="#000" />
                  </div>
                </div>
              )}
            <Flex justifyContent="space-between">
              {/* 行情 */}
              <Flex>
                {/* <div> */}
                {poolData?.direction === 1 ? (
                  <div>
                    <CurrencyLogo
                      address={poolData?.token1?.address}
                      symbol={poolData?.token1?.symbol}
                      size="40px"
                      // firstimg
                    />
                    <CurrencyLogo address={poolData?.token0?.address} symbol={poolData?.token0?.symbol} size="40px" />
                  </div>
                ) : (
                  <div>
                    <CurrencyLogo
                      address={poolData?.token0?.address}
                      symbol={poolData?.token0?.symbol}
                      size="40px"
                      // firstimg
                    />
                    <CurrencyLogo address={poolData?.token1?.address} symbol={poolData?.token1?.symbol} size="40px" />
                  </div>
                )}

                {/* </div> */}
                <Flex position="relative" flexDirection="column" style={{ marginLeft: '6px' }}>
                  <Text bold ml="5px" fontSize="16px" lineHeight="28px">
                    {poolData?.direction === 1
                      ? `${poolData?.token1?.symbol} / ${poolData?.token0?.symbol}`
                      : `${poolData?.token0?.symbol} / ${poolData?.token1?.symbol}`}
                    {/* {`${poolData?.token0?.symbol} / ${poolData?.token1?.symbol}`} */}
                  </Text>
                  {poolData?.direction === 1 ? (
                    <Flex alignItems="center" style={{ height: '14px', marginLeft: '4px' }}>
                      <CopyButton
                        width="24px"
                        text={poolData?.token1?.address}
                        address={poolData?.token1?.address}
                        iconColor
                        tooltipMessage={t('noah179')}
                        tooltipTop={50}
                        tooltipRight={120}
                      />
                      <Text color="#92929B" mr="10px" fontSize="12px">
                        |
                      </Text>
                      <CopyButton
                        width="24px"
                        text={poolData?.token0?.address}
                        address={poolData?.token0?.address}
                        iconColor
                        tooltipMessage={t('noah179')}
                        tooltipTop={50}
                        tooltipRight={-20}
                      />
                    </Flex>
                  ) : (
                    <Flex alignItems="center" style={{ height: '14px', marginLeft: '4px' }}>
                      <CopyButton
                        width="24px"
                        text={poolData?.token0?.address}
                        address={poolData?.token0?.address}
                        iconColor
                        tooltipMessage={t('noah179')}
                        tooltipTop={50}
                        tooltipRight={120}
                      />
                      <Text color="#92929B" mr="10px" fontSize="12px">
                        |
                      </Text>
                      <CopyButton
                        width="24px"
                        text={poolData?.token1?.address}
                        address={poolData?.token1?.address}
                        iconColor
                        tooltipMessage={t('noah179')}
                        tooltipTop={50}
                        tooltipRight={-20}
                      />
                    </Flex>
                  )}
                </Flex>
              </Flex>
              <Flex justifyContent="space-between" alignSelf="flex-end">
                {poolData?.token0?.address && poolData?.token1?.address && (
                  <NextLinkFromReactRouter to={`/add/${poolData?.token0?.address}/${poolData?.token1?.address}`}>
                    <StyledButton style={{ marginLeft: '10px' }}>{t('noah10')}</StyledButton>
                  </NextLinkFromReactRouter>
                )}
                <NextLinkFromReactRouter
                  to={`/swap?inputCurrency=${poolData?.token0.address}&outputCurrency=${poolData?.token1.address}`}
                >
                  <StyledButton variant="secondary" style={{ borderColor: '#000', marginLeft: '12px' }}>
                    {t('noah80')}
                  </StyledButton>
                </NextLinkFromReactRouter>
                <LinkExternal href={getBlockExploreLink(address, 'address')} showIcon={false}>
                  <StyledButton variant="secondary" style={{ borderColor: '#000', marginLeft: '15px' }}>
                    {t('noah6')}
                  </StyledButton>
                </LinkExternal>
              </Flex>
            </Flex>
          </div>
        )}
        <ContentLayout>
          {/* height="420px" */}
          <Box>
            <Card style={{ background: '#fff', height: '100%' }}>
              <Box p="24px">
                <div
                  style={{
                    // borderBottom: '1px solid #F3F3F3',
                    // paddingBottom: '20px',
                    display: isMobile && 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <div>
                    {/* 价格 */}
                    <Box mb="10px">
                      {poolData?.direction === 1 ? (
                        <Text color="#666666" fontSize="12px">
                          {t('noah81')}
                          {`(${poolData?.token1?.symbol}/${poolData?.token0?.symbol})`}
                        </Text>
                      ) : (
                        <Text color="#666666" fontSize="12px">
                          {t('noah81')}
                          {`(${poolData?.token0?.symbol}/${poolData?.token1?.symbol})`}
                        </Text>
                      )}

                      <Flex alignItems="center">
                        <Text fontSize="18px" mr="5px">
                          {formatNumber(formatPrice(poolData?.price), poolData?.price)}
                          {/* {poolData?.price} */}
                        </Text>
                        {poolData?.priceUsd ? (
                          <Text fontSize="12px" color="#92929B">
                            ${formatNumber(formatUsd(poolData?.priceUsd), poolData?.priceUsd)}
                          </Text>
                        ) : (
                          <Text fontSize="12px" color="#92929B">
                            &nbsp;
                          </Text>
                        )}
                        {priceChange && (
                          <Text
                            color={poolData?.priceChange > 0 ? 'green' : poolData?.priceChange < 0 ? 'red' : ''}
                            textAlign="right"
                            style={{ fontWeight: 'bold' }}
                          >
                            &nbsp;&nbsp;{priceChange}%
                          </Text>
                        )}
                      </Flex>
                    </Box>
                    <Box mb="10px">
                      <Text color="#666666" fontSize="12px">
                        {t('noah82')}
                      </Text>
                      <Flex>
                        <Text fontSize="18px" mr="10px">
                          ${formatAmount(poolData?.volumeUSD)}
                        </Text>
                      </Flex>
                    </Box>
                  </div>
                  <div style={{ width: '115px' }}>
                    {/* 24h Fees  */}
                    <Box mb="10px">
                      <Text color="#666666" fontSize="12px">
                        {t('noah83')}
                      </Text>
                      <Text fontSize="18px" mr="10px">
                        ${formatAmount(poolData?.totalFees24h)}
                      </Text>
                    </Box>
                    {/* 流动性年化 */}
                    <Box mb="10px">
                      <Text color="#666666" fontSize="12px">
                        {t('noah84')}
                      </Text>
                      <Text fontSize="18px" mr="10px">
                        {formatAmount(poolData?.lpApr7d * 100)}%
                      </Text>
                    </Box>
                  </div>
                </div>

                <div
                  style={{
                    borderBottom: '1px solid #F3F3F3',
                    paddingBottom: '20px',
                  }}
                >
                  {poolData?.isFarm && (
                    <div>
                      {/* 农场年化 */}
                      <Box mb="10px">
                        <Text color="#666666" fontSize="12px">
                          {t('noah281')}
                          {locale !== 'zh-TW' && <span>&nbsp;</span>}
                          {t('noah288')}
                        </Text>
                        <Text fontSize="18px" mr="10px">
                          {poolData?.farm_total_yield - poolData?.farm_fee_yield > 0 ? (
                            <Link href="/farms">
                              <div style={{ cursor: 'pointer' }}>
                                {Number(
                                  truncateZero((poolData?.farm_total_yield - poolData?.farm_fee_yield) * 100, 2),
                                ) > 100000 ? (
                                  <span>&gt;100000%</span>
                                ) : (
                                  <span>
                                    {truncateZero((poolData?.farm_total_yield - poolData?.farm_fee_yield) * 100, 2)}%
                                  </span>
                                )}{' '}
                                {poolData?.farm_total_yield_high - poolData?.farm_fee_yield > 0 ? (
                                  <span>~ </span>
                                ) : (
                                  <span></span>
                                )}
                                {Number(
                                  truncateZero((poolData?.farm_total_yield_high - poolData?.farm_fee_yield) * 100, 2),
                                ) > 200000 ? (
                                  <span>&gt;200000%</span>
                                ) : (
                                  <span>
                                    {poolData?.farm_total_yield_high - poolData?.farm_fee_yield > 0 ? (
                                      <span>
                                        {truncateZero(
                                          (poolData?.farm_total_yield_high - poolData?.farm_fee_yield) * 100,
                                          2,
                                        )}
                                        %
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                  </span>
                                )}
                                {/* {truncateZero(item.total_yield_high * 100, 2)}% */}
                              </div>
                            </Link>
                          ) : (
                            <div>-</div>
                          )}
                        </Text>
                      </Box>
                    </div>
                  )}
                </div>
                {/* 流动池锁定数量 */}
                <Text color="#666666" mt="24px" fontSize="12px">
                  {t('noah108')}
                </Text>
                <LockedTokensContainer>
                  <Flex justifyContent="space-between">
                    <Flex>
                      <CurrencyLogo address={poolData?.token0?.address} symbol={poolData?.token0?.symbol} size="24px" />
                      <Text small color="textSubtle" ml="8px">
                        {poolData?.token0?.symbol}
                      </Text>
                    </Flex>
                    <Text small width={isMobile ? 110 : ''}>
                      {formatAmount(poolData?.liquidityToken0)}
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <Flex>
                      <CurrencyLogo address={poolData?.token1?.address} symbol={poolData?.token1?.symbol} size="24px" />
                      <Text small color="textSubtle" ml="8px">
                        {poolData?.token1?.symbol}
                      </Text>
                    </Flex>
                    <Text small width={isMobile ? 110 : ''}>
                      {formatAmount(poolData?.liquidityToken1)}
                    </Text>
                  </Flex>
                </LockedTokensContainer>
              </Box>
            </Card>
          </Box>
          <ChartCard
            variant="pool"
            chartData={chartData}
            tokenPriceData={tokenPriceData}
            KLineTime={KLineTime}
            setKLineTime={setKLineTime}
            showKline={showKline}
            pairId={address}
            poolData={poolData}
          />
        </ContentLayout>
        <Heading mb="16px" mt="16px" scale="lg">
          {/* {t('Transactions')} */}
        </Heading>
        <TransactionTable transactions={transactions} setType={setType} type={type} loading={loading} />
      </>
      {/* ) : (
        <Flex mt="80px" justifyContent="center">
          <img src="/images/small-img/loading.gif" width={200} alt="" />
        </Flex>
      )} */}
    </Page>
  )
}

export default PoolPage
